import { render, staticRenderFns } from "./assistant-panel.vue?vue&type=template&id=43745c45&scoped=true"
import script from "./assistant-panel.vue?vue&type=script&lang=js"
export * from "./assistant-panel.vue?vue&type=script&lang=js"
import style0 from "./assistant-panel.vue?vue&type=style&index=0&id=43745c45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43745c45",
  null
  
)

export default component.exports